import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import DesignCloud from "./routes/DesignCloud";
import OrderForm from "./routes/OrderForm";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const App = () => (
    <Router>
        <Switch>
            <Route exact path="/">
                <Redirect to="/app" />
            </Route>
            <Route path="/app" component={DesignCloud} />
            <Route path="/orderform" component={OrderForm} />
        </Switch>
    </Router>
);

export default App;
